var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Delivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-delivery",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7191",
    "data-name": "Rectangle 7191",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery-truck-icon",
    transform: "translate(1 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M16.908,3.354l-3.22-.018V1.169A1.174,1.174,0,0,0,12.519,0H3.594a1.158,1.158,0,0,0-.826.344,1.165,1.165,0,0,0-.344.826.317.317,0,0,0,.634,0A.538.538,0,0,1,3.594.634h8.925a.538.538,0,0,1,.535.535v9.923H11.267a.317.317,0,0,0,0,.634h2.1a.316.316,0,0,0,.317-.317v-.36H15.6c.145-3.3,4.882-3.753,5.363,0H22l-.321-3.442L18.269,6.3,16.908,3.354ZM.475,6.722C.211,6.722,0,6.579,0,6.4s.213-.319.475-.319H4.753c.263,0,.475.143.475.319s-.213.319-.475.319Zm.98-1.716a.319.319,0,1,1,0-.634h3.3a.319.319,0,1,1,0,.634Zm.453-1.716a.338.338,0,0,1-.356-.317.338.338,0,0,1,.356-.317H4.753a.338.338,0,0,1,.356.317.338.338,0,0,1-.356.317Zm2.831,7.8a.317.317,0,1,1,0,.634H3.594a1.15,1.15,0,0,1-.826-.36,1.222,1.222,0,0,1-.344-.84V8.2a.317.317,0,1,1,.634,0v2.328a.584.584,0,0,0,.165.4.516.516,0,0,0,.369.165H4.738ZM7.962,9.02a2.147,2.147,0,1,0,2.147,2.147A2.148,2.148,0,0,0,7.962,9.02Zm0,1.322a.826.826,0,1,0,.826.826.826.826,0,0,0-.826-.826ZM18.276,9.02a2.147,2.147,0,1,0,2.147,2.147A2.148,2.148,0,0,0,18.276,9.02Zm0,1.322a.826.826,0,1,0,.826.826.826.826,0,0,0-.826-.826Zm-2.2-6.078-1.6-.018V6.3h2.681l-1.082-2.04Z",
    fill: "#02466a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Delivery);
export default __webpack_public_path__ + "static/media/icon-24-delivery.bf10523fa0671a7d45f523bd1f84d1a8.svg";
export { ForwardRef as ReactComponent };